import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class ClientHttp {
  constructor(protected httpService: HttpService) {}

  clientsCountByType = (searchParams) => this.httpService.get(`/admin/crmx/count`, searchParams);

  getClientListByType = (searchParams) => this.httpService.get(`/admin/crmx`, searchParams);

  clientQuickSearchCount = ({ type, search }) => {
    let params = {
      type,
      search,
    };
    return this.httpService.get(`/admin/crm/clients-quick-search/count`, params);
  };
  clientQuickSearch = ({ type, search, page = 0, size = 10 }) => {
    let params = {
      type,
      search,
      page,
      size,
    };
    return this.httpService.get(`/admin/crm/clients-quick-search`, params);
  };
  addIndividualClient = (formData) => this.httpService.post(`/admin/crm/individual-clients`, formData);

  addCorporateClient = (formData) => this.httpService.post(`/admin/crm/corporate-clients`, formData);
  getDuplicateProfileCount = (params, clientType) =>
    this.httpService.get(`/admin/crm/search/duplicate-${clientType}-clients/count`, params);
  getDuplicateProfile = (params, clientType, listQuery) =>
    this.httpService.get(`/admin/crm/search/duplicate-${clientType}-clients`, {
      ...params,
      size: listQuery.take,
      page: listQuery.skip / listQuery.take || 0,
    });
  upCommingBirthDates = (id) => this.httpService.get(`/admin/crm/individual-clients/up-comming-birth-dates${(id && '?rmId=' + id) || ''}`);
  filterClientRequest = (listQuery) =>
    this.httpService.get(
      `/client-request/search?requestType=${listQuery.filterValues.requestType || ''}&requestStatus=${
        listQuery.filterValues.requestStatus || ''
      }&userId=${listQuery.filterValues.userId || ''}`
    );

  changeRequestStatus = (formData, requestId, status) =>
    this.httpService.put(`/client-request?requestId=${requestId}&status=${status}`, formData);
}

@Injectable()
export class ClientService {
  emitChange$: Subject<any> = new BehaviorSubject<any>(null);
  constructor(protected http: ClientHttp) {}
  emit(value: any) {
    this.emitChange$.next(value);
  }
  get emitChange(): BehaviorSubject<any> {
    return this.emitChange$ as BehaviorSubject<any>;
  }
  async clientsCountByType(searchParams) {
    return await this.http.clientsCountByType(searchParams);
  }

  async getClientListByType(searchParams) {
    return this.http.getClientListByType(searchParams);
  }

  async clientQuickSearchCount(searchParams) {
    return this.http.clientQuickSearchCount(searchParams);
  }
  async clientQuickSearch(searchParams) {
    return this.http.clientQuickSearch(searchParams);
  }
  addIndividualClient = async (formData) => this.http.addIndividualClient(formData);

  addCorporateClient = async (formData) => this.http.addCorporateClient(formData);
  getDuplicateProfileCount = async (params, clientType) => this.http.getDuplicateProfileCount(params, clientType);
  getDuplicateProfile = async (params, clientType, listQuery) => this.http.getDuplicateProfile(params, clientType, listQuery);
  upCommingBirthDates = async (id?) => this.http.upCommingBirthDates(id);
  filterClientRequest = async (listQuery) => this.http.filterClientRequest(listQuery);
  changeRequestStatus = async (formData, requestId, status) => this.http.changeRequestStatus(formData, requestId, status);
}
